module.exports = __webpack_public_path__ + "static/media/pancakeswap-bot.e80efb58.md";